module.exports = __webpack_public_path__ + "img/border9.515c5ff7.png";